import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  id: "app"
};
import RouteTracker from "./views/RouteTracker.vue";
import { onMounted, watch } from "vue";
import BasicLayout from "@/components/layout/BasicLayout.vue";
import { useRoute } from "vue-router";
import zhCN from "ant-design-vue/es/locale/zh_CN";
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    // 设置页面标题的函数
    const setTitle = title => {
      document.title = "牛站 - " + (title || ''); // 修复逻辑
    };
    watch(route, to => {
      setTitle(to.name); // 使用路由的 name 作为标题
    }, {
      immediate: true
    });
    const doInit = () => {
      console.log("欢迎来到小牛知识分享平台~");
      // 检查 route.name 是否有效
      if (route.name) {
        setTitle(route.name);
      } else {
        setTitle(''); // 设置为默认标题
      }
    };
    onMounted(() => {
      doInit();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      return _openBlock(), _createBlock(_component_a_config_provider, {
        locale: _unref(zhCN)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(RouteTracker), _unref(route).path.startsWith('/user') ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0
        })) : (_openBlock(), _createBlock(BasicLayout, {
          key: 1
        }))])]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});